<template>
  <div class="invoice-set">
    <table width="90%" align="center" class="invoice-table mx-auto mt-10">
      <tbody>
        <tr>
          <td align="center">
            <span class="text-4xl">
              <strong>{{ parentUser.business_name }}</strong
              ><br />
              {{ parentUser.address }}<br />
            </span>
          </td>
        </tr>
        <tr>
          <td align="center" class="text-4xl"><strong>-----------------Invoice----------------</strong></td>
        </tr>
        <tr>
          <td>
            <table width="100%" class="mt-5 text-2xl">
              <tbody>
                <tr>
                  <td width="40%">Invoice</td>
                  <td>
                    <b>#{{ sale.sales_code }}</b>
                  </td>
                </tr>
                <tr>
                  <td width="40%">License Number</td>
                  <td>{{ parentUser.omma_license_number }}</td>
                </tr>
                <tr>
                  <td width="40%">Customers License</td>
                  <td>{{ sale.customer && sale.customer.license_number }}</td>
                </tr>
                <tr>
                  <td width="40%">Date:</td>
                  <td style="text-align: right">{{ formatDate(sale.sales_date) }}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <table width="100%" class="text-2xl" cellpadding="0" cellspacing="0">
              <thead>
                <tr class="border-dotted border-4 border-light-blue-500">
                  <td></td>
                  <td style="text-align: left">#</td>
                  <td style="text-align: left">Description</td>
                  <td style="text-align: left">Category</td>
                  <td style="text-align: left">Quantity</td>
                  <td style="text-align: left">Weight Type</td>
                  <td style="text-align: left">Price</td>
                  <td style="text-align: right">Total</td>
                  <!-- <td style="text-align: right">Exit Label</td> -->
                </tr>
              </thead>

              <tbody style="border-bottom-style: dashed; border-bottom-color: #000; border-width: 0.1px">
                <tr :key="i" v-for="(tr, i) in invoice_items">
                  <td class="flex justify-content-center"><vs-checkbox v-model="selectedProducts" :vs-value="tr.product.id"></vs-checkbox></td>
                  <td align="left">{{ i + 1 }}</td>
                  <td align="left">
                    {{
                      `${tr.product_name} - 
                    (${tr.batch && tr.batch.batch_number})`
                    }}
                  </td>
                  <td align="left">{{ tr.product && tr.product.category && tr.product.category.category_name }}</td>
                  <td align="left">{{ tr.sales_qty | weightFilter }}</td>
                  <td align="left">{{ tr.weight_type }}</td>
                  <td align="left">$ {{ tr.price_per_unit | currencyFilter }}</td>
                  <td align="right">$ {{ calculateProductSubTotal(tr) | currencyFilter }}</td>
                  <!-- <td align="right"><button @click="toggleGenerateLabelPopup(tr)">Print Exit Label</button></td> -->
                </tr>
              </tbody>

              <tfoot>
                <tr>
                  <td colspan="7" align="right">Subtotal</td>
                  <td align="right">$ {{ invoice_subTotal | currencyFilter }}</td>
                </tr>
                <tr>
                  <td colspan="7" align="right">Discount</td>
                  <td align="right">$ {{ invoice_discount | currencyFilter }}</td>
                </tr>

                <!-- redeem amount -->
                <tr>
                  <td colspan="7" align="right">Redeem Amount</td>
                  <td align="right">$ {{ calculateRedeemDollar | currencyFilter }}</td>
                </tr>

                <tr v-if="invoice_city_tax">
                  <td colspan="7" align="right">City Tax</td>
                  <td align="right">$ {{ invoice_city_tax | currencyFilter }}</td>
                </tr>
                <tr v-if="invoice_state_tax">
                  <td colspan="7" align="right">State Tax</td>
                  <td align="right">$ {{ invoice_state_tax | currencyFilter }}</td>
                </tr>
                <tr v-if="invoice_excise_tax">
                  <td colspan="7" align="right">Excise Tax</td>
                  <td align="right">$ {{ invoice_excise_tax | currencyFilter }}</td>
                </tr>
                <tr v-if="invoice_county_tax">
                  <td colspan="7" align="right">County Tax</td>
                  <td align="right">$ {{ invoice_county_tax | currencyFilter }}</td>
                </tr>
                <tr>
                  <td colspan="7" align="right">Total Tax</td>
                  <td align="right">$ {{ invoice_tax | currencyFilter }}</td>
                </tr>

                <tr>
                  <td colspan="7" align="right">Total</td>
                  <td align="right">$ {{ invoice_grand_total | currencyFilter }}</td>
                </tr>

                <tr>
                  <td colspan="7" align="right">Paid Payment</td>
                  <td align="right">$ {{ invoice_paid_amount | currencyFilter }}</td>
                </tr>

                <tr>
                  <td colspan="7" align="right">Due Amount</td>
                  <td align="right">$ {{ calculate_due_amount | currencyFilter }}</td>
                </tr>

                <tr v-if="calculate_change_due_amount">
                  <td colspan="7" align="right">Change Due</td>
                  <td align="right">$ {{ calculate_change_due_amount | currencyFilter }}</td>
                </tr>

                <tr>
                  <td>Payment Note :</td>
                  <td colspan="6">{{ sale.salesPayments && sale.salesPayments[0].payment_note }}</td>
                </tr>

                <tr>
                  <td colspan="9" align="center">
                    <button style="background-color: red; color: white" @click="toggleGenerateMultipleLabelPopup()">Print Exit Label</button>
                  </td>
                </tr>

                <tr>
                  <td colspan="9" align="center">
                    <div style="display: inline-block; vertical-align: middle; line-height: 16px !important">
                      <bar-code v-if="sale.sales_code" :options="options" :value="sale.sales_code" />
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </td>
        </tr>
      </tbody>
      <div class="no-print"><button class="print-btn d-block" @click="printInvoice">Print</button></div>
    </table>
    <div v-html="html" />

    <generate-label-popup v-if="isGenerateLabelPopupMounted" :isModelShow.sync="isGenerateLabelPopupShow" :productId="productId" :saleId="saleId" />
  </div>
</template>

<script>
import Vue from 'vue'
import LoadScript from 'vue-plugin-load-script'
import { mapState } from 'vuex'
import { dateMixins } from '@/mixins/dateMixins.js'
import { POSFunctionalMixins } from '@/mixins/functionalMixins.js'
import { paymentMixins } from '@/utils/paymentTypes'
import { weightMixins } from '@/utils/weightType'
import GenerateLabelPopup from '@/views/pos/components/GenerateLabelPopup.vue'
import BarCode from '@/components/utils/BarCode.vue'
import { taxMode, discountApplicableType } from '@/utils/enums'

Vue.use(LoadScript)

export default {
  name: 'PosInvoicePrint',

  props: {
    sale: {
      type: Object
    },
    salesItems: Array
  },

  components: {
    GenerateLabelPopup,
    BarCode
  },

  data: () => ({
    html: `
    <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css" integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T" crossorigin="anonymous"> 
    <link rel="preconnect" href="https://fonts.gstatic.com">
    <link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;700;800&display=swap" rel="stylesheet">
    <style>   
    
        body {
          color: #000 !important;
        }

        .invoice-table{
            magin:0 auto;
        }
        .invoice-set {
            margin: 0 auto;
        }
        * {
          font-family: Merchant-Double;
          font-weight: bold;
          color: #000;
        }
        .border-dotted {
          border-color: #000;
        }
        .print-btn {
          margin: 0 auto;
          margin-top: 15px;
          padding: 5px;
          width: 63px;
          border: none;
          background: #28C76F;
          color: white;
          border-radius: 10px;
        }
        @media print {
          .no-print { display: none; }
        }         
    </style>`,
    options: {
      width: 3,
      height: 70,
      displayValue: false
    },

    // generate label popup
    selectedProducts: [],
    productId: null,
    saleId: null,
    isGenerateLabelPopupMounted: false,
    isGenerateLabelPopupShow: false
  }),

  mixins: [paymentMixins, weightMixins, dateMixins, POSFunctionalMixins],

  // mounted
  mounted() {
    this.$loadScript('https://code.jquery.com/jquery-3.3.1.slim.min.js')
      .then(() => {
        this.$loadScript('https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.7/umd/popper.min.js')
          .then(() => {
            this.$loadScript('https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/js/bootstrap.min.js')
              .then(() => {
                this.$emit('print-ready')
              })
              .catch(() => {
                this.$emit('print-ready')
              })
          })
          .catch(() => {})
      })
      .catch(() => {})
  },

  computed: {
    ...mapState('product', ['categories']),
    ...mapState('auth', ['parentUser']),

    // calculate product sub total
    calculateProductSubTotal() {
      return (tr) => {
        return paymentMixins.methods.mathRound(tr.tot_price, 2)
      }
    },

    // calculate sub_total (invoice) = qty * price
    invoice_subTotal() {
      const subTotal = this.invoice_items.reduce((acc, item) => {
        const tempTotal = item.tot_price
        acc = acc + tempTotal

        return acc
      }, 0)

      return paymentMixins.methods.mathRound(subTotal, 2)
    },

    // invoice items
    invoice_items() {
      return this.salesItems.reduce((acc, item) => {
        if (item.sales_qty > 0) {
          acc.push(item)
        }

        return acc
      }, [])
    },

    // invoice tax
    invoice_tax() {
      const totalTax = this.invoice_items.reduce((acc, item) => acc + item.tot_taxes_amt, 0)
      return paymentMixins.methods.mathRound(totalTax, 2)
    },

    invoice_paid_amount() {
      const paidAmount = (this.sale.salesPayments || []).reduce((acc, item) => {
        acc += item.payment_amount
        return acc
      }, 0)

      return paymentMixins.methods.mathRound(paidAmount, 2)
    },

    // city tax
    invoice_city_tax() {
      const totalCityTax = this.invoice_items.reduce((acc, item) => acc + item.city_tax_amt, 0)
      return paymentMixins.methods.mathRound(totalCityTax, 2)
    },

    // state tax
    invoice_state_tax() {
      const totalStateTax = this.invoice_items.reduce((acc, item) => acc + item.state_tax_amt, 0)
      return paymentMixins.methods.mathRound(totalStateTax, 2)
    },

    //excise tax
    invoice_excise_tax() {
      const totalExciseTax = this.invoice_items.reduce((acc, item) => acc + item.excise_tax_amt, 0)
      return paymentMixins.methods.mathRound(totalExciseTax, 2)
    },

    //county tax
    invoice_county_tax() {
      const totalCountyTax = this.invoice_items.reduce((acc, item) => acc + item.county_tax_amt, 0)
      return paymentMixins.methods.mathRound(totalCountyTax, 2)
    },

    // invoice discount
    invoice_discount() {
      const totalDiscount = this.invoice_items.reduce((acc, item) => acc + item.tot_discount, 0)
      return paymentMixins.methods.mathRound(totalDiscount, 2)
    },

    // invoice post tax discount
    invoice_post_tax_discount() {
      return this.invoice_items.reduce((acc, item) => {
        if (this.sale.tax_mode === taxMode.taxNotIncluded && item.discount_amount_type === discountApplicableType.postTax) {
          acc += item.tot_discount
        }

        return acc
      }, 0)
    },

    // invoice grand total = sub total - discount + tax
    invoice_grand_total() {
      const tempTotal = this.invoice_subTotal + this.invoice_tax
      return paymentMixins.methods.mathRound(tempTotal, 2)
    },

    // calculate redeem dollar
    calculateRedeemDollar() {
      const returnRedeemDollar = this.sale && this.sale.sales_return && this.sale.sales_return.salesItemsReturn.reduce((acc, item) => acc + item.return_redeem_dollar, 0)
      return Math.max(0, this.salesItems.reduce((acc, item) => acc + item.redeem_dollar, 0) - returnRedeemDollar)
    },

    // due amount
    calculate_due_amount() {
      const dueAmount = Math.max(this.invoice_grand_total - this.invoice_paid_amount, 0)
      return Math.max(0, paymentMixins.methods.mathRound(dueAmount, 2))
    },

    // calculate change due
    calculate_change_due_amount() {
      const changeDue = this.invoice_paid_amount - this.invoice_grand_total
      return Math.max(0, paymentMixins.methods.mathRound(changeDue, 2))
    }
  },

  methods: {
    printInvoice() {
      this.$nextTick(() => {
        window.print()
      })
    },

    // toggle generate label popup
    toggleGenerateLabelPopup(data) {
      this.productId = [data.productId]
      this.saleId = data.salesId
      this.isGenerateLabelPopupMounted = true
      this.isGenerateLabelPopupShow = true
    },

    toggleGenerateMultipleLabelPopup() {
      this.productId = this.selectedProducts
      this.saleId = this.sale.id
      this.isGenerateLabelPopupMounted = true
      this.isGenerateLabelPopupShow = true
    }
  },

  filters: {
    // currencyFilter rounded to 2 point
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(Number(value), 2)
    },

    //weightFilter rounded conversation
    weightFilter(value) {
      return weightMixins.methods.mathRound(Number(value), 3)
    }
  },

  watch: {
    // handle callback for generate label popup
    isGenerateLabelPopupShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isGenerateLabelPopupMounted = false
            this.productId = null
            this.salesId = null
          }, 0)
        }
      }
    }
  },

  beforeRouteLeave(_, __, next) {
    // ...
    this.isGenerateLabelPopupShow = false

    next()
  }
}
</script>
<style>
@font-face {
  font-family: 'Merchant';
  src: url('../../../assets/fonts/merchant.ttf') format('truetype'); /* Safari, Android, iOS */
}
@font-face {
  font-family: 'Merchant-Double';
  src: url('../../../assets/fonts/merchant.doublesize.ttf') format('truetype'); /* Safari, Android, iOS */
}
@font-face {
  font-family: 'Merchant-Wide';
  src: url('../../../assets/fonts/merchant.wide.ttf') format('truetype'); /* Safari, Android, iOS */
}
</style>
<style lang="scss">
body {
  height: 50%;
}

.invoice-set {
  .vs-checkbox {
    margin-top: 5px;
    border: 2px solid #000 !important;
  }
}
</style>
